import { render, staticRenderFns } from "./CompanyCustom.vue?vue&type=template&id=0e820e3a&scoped=true"
import script from "./CompanyCustom.vue?vue&type=script&lang=js"
export * from "./CompanyCustom.vue?vue&type=script&lang=js"
import style0 from "./CompanyCustom.vue?vue&type=style&index=0&id=0e820e3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e820e3a",
  null
  
)

export default component.exports